import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers, compose, withHandlers } from 'recompose';
import { Modal, Button, ButtonToolbar, Clearfix, ControlLabel, FormControl, Row, Col, FormGroup } from 'react-bootstrap';


export const withUnreviewReasonModalState = withStateHandlers(
  (props) => {
    return {
      showUnreviewReasonModal: false,
      unreviewReasonError: null,
      unreviewReasonDisabled: false,
    };
  },
  {
    clearUnreviewReasonError: (state, props) => {
      return () => { return { unreviewReasonError: null }; };
    },
    setUnreviewReasonError: (state, props) => {
      return (error) => { return { unreviewReasonError: error }; };
    },
    setUnreviewReasonDisabled: (state, props) => {
      return (disabled) => { return { unreviewReasonDisabled: disabled }; };
    },
    openUnreviewReasonModal: (state, props) => {
      return () => { return { showUnreviewReasonModal: true }; };
    },
    closeUnreviewReasonModal: (state, props) => {
      return () => { return { showUnreviewReasonModal: false, unreviewReasonError: null }; };
    },
  },
);


export const unreviewReasonModalPropTypes = {
  setUnreviewReasonDisabled: PropTypes.func.isRequired,
  unreviewReasonDisabled: PropTypes.bool.isRequired,
  unreviewReasonError: PropTypes.string,
  setUnreviewReasonError: PropTypes.func.isRequired,
  clearUnreviewReasonError: PropTypes.func.isRequired,
  openUnreviewReasonModal: PropTypes.func.isRequired,
  closeUnreviewReasonModal: PropTypes.func.isRequired,
  showUnreviewReasonModal: PropTypes.bool.isRequired,
};

export const UnreviewReasonModal = (props) => {
  const {
    show, onReasonChange, submit, reason, hideModal, disabled, error,
  } = props;

  return (
    <Modal show={show} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Unreview Reason</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormGroup>
            <Row>
              <Col md={12}>
                <ControlLabel>Reason</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  name="reason"
                  value={reason}
                  onChange={onReasonChange}
                />
              </Col>
            </Row>
          </FormGroup>
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Clearfix />
        <ButtonToolbar className="pull-right">
          <Button
            bsStyle="warning"
            onClick={hideModal}
          >
            Cancel
          </Button>
          <Button
            bsStyle="danger"
            onClick={submit}
            disabled={disabled}
          >
            Return to Field Admin
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  );
};


const withState = withStateHandlers((props) => { return { reason: '' }; }, {
  onReasonChange: (state, props) => {
    return (e) => { return { reason: e.target.value }; };
  },
  clearReason: (state, props) => {
    return () => { return { reason: '' }; };
  },
});


const withClearAndHide = withHandlers({
  hideModal: (props) => {
    return () => {
      const { onHide, clearReason } = props;
      clearReason();
      onHide();
    };
  },
});


const withSubmit = withHandlers({
  submit: (props) => {
    return () => {
      const { reason, setError, onSubmit } = props;
      if (reason === '') {
        setError('Must provide a reason to send the job back to the manager');
        return;
      }
      onSubmit(reason);
    };
  },
});


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  onHide: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  error: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  onSubmit: PropTypes.func.isRequired,
  onReasonChange: PropTypes.func.isRequired,
  reason: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  clearReason: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  setError: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
});


UnreviewReasonModal.propTypes = propTypes;


const enhance = compose(
  withState,
  withClearAndHide,
  withSubmit,
);


export default enhance(UnreviewReasonModal);
